import React from "react";
import SEO from "../Components/SEO";
import Carousel from "../Components/Carousel";
import { Link } from "react-router-dom";
import "../Pages/Home.css";
import Owl from "../Components/Owl";
import "../Pages/OurHistory.css";
import CardOwl from "../Components/CardOwl";
import ShadowCard from "../Components/ShadowCard";
import Objectives from "../Components/Objectives";
import "./NewsandEvents.css";

const scrollToTop = () => window.scrollTo(0, 0);

function Home() {
  return (
    <div className="ne-page">
      <SEO
        title="Centre for Integrated Research and Community Development Uganda"
        description="CIRCODU is a leading Ugandan research and community development organisation dedicated to advancing clean energy solutions, energy access, environmental monitoring, and community-based research since 2007 through rigorous research, innovative projects, and impactful partnerships across Uganda and the region."
        keywords="CIRCODU, clean cooking Uganda, cookstove testing, energy access research, community development Uganda, environmental monitoring, renewable energy"
        url="/"
        type="website"
      />

      {/* Carousel — first image is LCP, handled inside Carousel component */}
      <Carousel />

      {/* Director General's Message */}
      <section className="section">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 text-center">
              <br />
              <h2 className="main-heading" style={{ color: "#008250" }}>
                Message From The Director General
              </h2>
              <div className="underline-card2 mx-auto" />
              <p className="texthome">
                Welcome, and thank you for taking the time to visit us.
              </p>
              <p className="texthome">
                On behalf of the entire CIRCODU family, it is my sincere
                pleasure to greet you here. Whether you are a long-standing
                partner, a prospective collaborator, or someone discovering our
                work for the very first time, you are warmly welcome, and we
                are glad you are here.
              </p>
              <p className="texthome">
                CIRCODU was built on the conviction that research, done well
                and applied purposefully, can transform lives. Since our
                inception in 2007, that conviction has only deepened. We have
                watched communities gain access to clean energy, cleaner water,
                and the knowledge to build better futures for themselves. We
                have seen data shape policy, and policy shape lives. And with
                every project we undertake, every partnership we forge, and
                every community we serve, we are reminded of why this work
                matters.
              </p>
              <Link
                to="/the-team/top-management"
                className="read-more-btn"
                onClick={scrollToTop}
                aria-label="Read the full message from the Director General"
              >
                Read More
              </Link>
            </div>
          </div>
        </div>
      </section>

      <ShadowCard />
      <Objectives />

      {/* Thematic Areas + Partners */}
      <section className="section1 border-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 text-center mt-4">
              <h2 className="main-heading" style={{ color: "#008250" }}>
                Thematic Areas
              </h2>
              <div className="underline-card mx-auto" />
              <CardOwl />
            </div>
            <div className="col-md-12 text-center mt-4">
              <h2 className="main-heading" style={{ color: "#008250" }}>
                Our Clients and Partners
              </h2>
              <div className="underline-card2 mx-auto" />
              <br />
              <Owl />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;